import type { Destination } from '../types'
import type { Translator } from '../i18n/i18n'

interface CandidateListProps {
  candidates: Destination[]
  t: Translator
  onPick: (destination: Destination) => void
}

export function CandidateList({ candidates, t, onPick }: CandidateListProps) {
  if (candidates.length === 0) return null
  return (
    <section className="results" aria-labelledby="candidate-heading">
      <div className="section-heading">
        <div>
          <span className="step">1</span>
          <h2 id="candidate-heading">{t('candidateTitle')}</h2>
        </div>
        <span>{t('candidateCount', { count: candidates.length })}</span>
      </div>
      <div className="candidate-list">
        {candidates.map((candidate) => (
          <button className="candidate-card" type="button" key={candidate.id} onClick={() => onPick(candidate)}>
            <span className="pin" aria-hidden="true">⌖</span>
            <span>
              <strong><bdi>{candidate.name}</bdi></strong>
              <small><bdi>{candidate.address}</bdi></small>
              {candidate.coordinateStatus === 'DEMO_ONLY' && <em>{t('demoOnly')}</em>}
            </span>
            <span aria-hidden="true">›</span>
          </button>
        ))}
      </div>
    </section>
  )
}
